import type { AccordionGap, AccordionTheme } from './types';

/** Cor padrão quando o editor ainda não escolheu tema. */
export const DEFAULT_ACCORDION_THEME: AccordionTheme = 'dark-blue';

/** Espaçamento padrão entre painéis. */
export const DEFAULT_ACCORDION_GAP: AccordionGap = 'md';
